import React from 'react';
import {observer} from 'mobx-react';
import {action} from 'mobx';
import {
    FormGroup, FormControl, ControlLabel,
    Form, Row, Col, Checkbox, Button, ButtonToolbar, Alert
} from 'react-bootstrap';
import {LinkContainer} from 'react-router-bootstrap';

import AttachmentsForm from '../common_components/attachments/AttachmentsForm';
import {injectIntl} from 'react-intl';
import ButtonWithConfirmation from "../common_components/ButtonWithConfirmation";
import AITextEditor from '../AITextEditor';

@observer
class CustomerSegmentsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: "",
            name: "",
            need: "",
            targetClientNumber: 0,
            localization: "",
            description: "",
            attach_url: undefined,
            isEdition: false,
        };

        this.canDeleteCard = props.blockStore.rootStore.authorizationStore.canDeleteCard(props.blockStore.editingCard);

        this.renderSaveOrUpdateButton = this.renderSaveOrUpdateButton.bind(this);
        this.handleLabelChange = this.handleLabelChange.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleNeedChange = this.handleNeedChange.bind(this);
        this.handleTargetClientNumberChange = this.handleTargetClientNumberChange.bind(this);
        this.handleLocalizationChange = this.handleLocalizationChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleUpdate = this.handleUpdate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

    }

    render() {
        return (
            <div>
                {this.renderForm()}
            </div>
        );
    }

    renderForm() {

        const {blockStore, intl} = this.props;

        let cancelBtn;

        if (this.props.hideCancelBtn == null) {
            cancelBtn = <Button bsStyle="default" onClick={this.handleCancel}>
                {intl.formatMessage({id: "cancel"})}
            </Button>;
        } else {
            cancelBtn = <div></div>;
        }


        const labelValue = this.state.label.trim() ?
            intl.formatMessage({
                id: this.state.label,
                defaultMessage: " "
            }) : "";

        return (
            <div>

                {this.state.isEdition && (
                    <FormGroup
                        controlId="LabelCSId"
                        validationState={this.validateLabel()}>
                        <Row>
                            <Col xs={12} sm={2}>
                                <ControlLabel> {intl.formatMessage({id: "station"})} </ControlLabel>
                            </Col>
                            <Col xs={12} sm={10}>
                                <FormControl
                                    type="text"
                                    value={labelValue}
                                    placeholder=""
                                    onChange={this.handleLabelChange}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                )}


                <FormGroup
                    controlId="NameCSId"
                    validationState={this.validateName()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "name"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.name}
                                placeholder=""
                                onChange={this.handleNameChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup controlId="DescriptionCSId" validationState={this.validateDescription()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel>{intl.formatMessage({id: "description"})}</ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <AITextEditor
                                value={this.state.description}
                                onChange={(value) => this.setState({description: value})}
                                context="El texto con el que estás trabajando es sobre la descripción de segmentos de clientes en un modelo de negocio Canvas. Los segmentos de clientes son los diferentes grupos de personas u organizaciones a las que una empresa busca dirigirse y servir. Es importante describir características demográficas, necesidades, comportamientos y motivaciones específicas de cada segmento."
                                rows={4}
                                placeholder=""
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup
                    controlId="NeedCSId"
                    validationState={this.validateNeed()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "need"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.need}
                                placeholder=""
                                onChange={this.handleNeedChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup
                    controlId="LocalizationCSId"
                    validationState={this.validateLocalization()}>
                    <Row>
                        <Col xs={12} sm={2}>
                            <ControlLabel> {intl.formatMessage({id: "localization"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={10}>
                            <FormControl
                                type="text"
                                value={this.state.localization}
                                placeholder=""
                                onChange={this.handleLocalizationChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>

                <FormGroup
                    controlId="TargetClientNumberCSId"
                    validationState={this.validateTargetClientNumber()}>
                    <Row>
                        <Col xs={12} sm={4}>
                            <ControlLabel> {intl.formatMessage({id: "target-client-number"})} </ControlLabel>
                        </Col>
                        <Col xs={12} sm={8}>
                            <FormControl
                                type="number"
                                step="1"
                                value={this.state.targetClientNumber}
                                placeholder=""
                                onChange={this.handleTargetClientNumberChange}
                            />
                        </Col>
                    </Row>
                </FormGroup>


                <AttachmentsForm attachable={blockStore.editingCard}/>

                <br/>

                <ButtonToolbar className="pull-right">
                    {this.renderSaveOrUpdateButton()}

                    {this.state.isEdition && this.canDeleteCard && (
                        <ButtonWithConfirmation dropdownClassname="bmc-card-delete-button"
                                                confirmationMessage={intl.formatMessage({id: "delete_confirmation_msg"})}
                                                option1Label={intl.formatMessage({id: "delete_confirmation_no"})}
                                                option2Label={intl.formatMessage({id: "delete_confirmation_yes"})}
                                                onOption2Select={this.handleDelete}
                                                dropup>
                            {intl.formatMessage({id: "delete"})}
                        </ButtonWithConfirmation>
                    )}

                    {cancelBtn}

                </ButtonToolbar>

                <div className="clearfix"/>

            </div>
        );
    }

    renderSaveOrUpdateButton() {

        if (this.state.isEdition) {
            return (
                <Button bsStyle="primary" onClick={this.handleUpdate}>
                    {this.props.intl.formatMessage({id: "save"})}
                </Button>
            )
        } else {
            const buttonMessage = this.props.blockStore.rootStore.stepByStepMode ? "save" : "add";

            return (
                <Button bsStyle="primary" onClick={this.handleSubmit}
                        disabled={!this.state.name && !this.state.description}>
                    {this.props.intl.formatMessage({id: buttonMessage})}
                </Button>
            )
        }


    }

    handleLabelChange(e) {
        //this.setState({label: e.target.value});
    }

    handleNameChange(e) {
        this.setState({name: e.target.value});
    }

    handleNeedChange(e) {
        this.setState({need: e.target.value});
    }

    handleTargetClientNumberChange(e) {
        this.setState({targetClientNumber: e.target.value});
    }

    handleLocalizationChange(e) {
        this.setState({localization: e.target.value});
    }

    handleDescriptionChange(e) {
        this.setState({description: e.target.value});
    }


    validateLabel() {

    }

    validateName() {

    }

    validateNeed() {

    }

    validateTargetClientNumber() {

    }

    validateLocalization() {

    }

    validateDescription() {

    }

    @action
    handleSubmit() {
        const card = this.generateCardFromState();
        this.props.blockStore.addCard(card);
        this.props.blockStore.showBlockModal(false);

        this.resetForm();
    }


    @action
    handleCancel() {
        const {blockStore} = this.props;
        blockStore.hideBlockModal(true);

        this.resetForm();


    }

    @action
    handleUpdate() {
        let card = this.generateCardFromState();
        const {blockStore} = this.props;

        if (blockStore.editingCard) {
            blockStore.editingCard.update(card);
            blockStore.showBlockModal(false);
        }
    }


    @action
    handleDelete() {
        this.props.blockStore.editingCard.destroy();
        this.props.blockStore.hideBlockModal(true);

    }


    generateCardFromState() {
        const {editingCard} = this.props.blockStore;

        editingCard.label = this.state.label;
        editingCard.name = this.state.name;
        editingCard.need = this.state.need;
        editingCard.targetClientNumber = this.state.targetClientNumber;
        editingCard.localization = this.state.localization;
        editingCard.description = this.state.description;

        return editingCard;
    }

    resetForm() {
        this.setState({
            label: "",
            name: "",
            need: "",
            targetClientNumber: 0,
            localization: "",
            description: "",
            attach_url: undefined,

            isEdition: false,

        });
    }


    componentDidMount() {
        const {blockStore} = this.props;

        if (blockStore.editingCard) {
            this.initFields(blockStore.editingCard);
        }
    }

    initFields(card) {
        //const card = this.props.blockStore.editingCard;
        this.setState({
            label: card.label,
            name: card.name,
            need: card.need,
            targetClientNumber: card.targetClientNumber,
            localization: card.localization,
            description: card.description,

            isEdition: card.persisted,

        });
    }
}

export default injectIntl(CustomerSegmentsForm);